import { LitElement, css, html, TemplateResult } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { VaultFile } from './../../dataService/dto/VaultFile'
import { VaultFolder } from './../../dataService/dto/VaultFolder'
import { DataService } from './../../dataService/src/dataService';
import { VaultType } from './../../dataService/dto/VaultType'
import { FolderType } from '../../dataService/dto/FolderType';
import './../../accordion/src/committee-accordion'; // Import the accordion component

@customElement('audio-vault')
export class AudioVault extends LitElement {
 
    @property({ type: Number })
    sessionId = 0;
  
    @state()
    IsDataLoaded: boolean = false;

    @state()
    CommitteeData?: VaultFolder;

    override  connectedCallback(): void {
        super.connectedCallback();

        this.loadCommittees();
        this.addEventListener('accordion-toggled', this.handleAccordionToggle as EventListener);
    }

    override updated(): void {
        this.setupAudioEventListeners();
    }

    private handleAccordionToggle(event: CustomEvent) {
        const committee = event.detail.folder as VaultFolder;
   
        // Closing 
        this.toggleAllOpenAccordions(committee);

    }
    private toggleAllOpenAccordions(committee: VaultFolder) {
        const accordions = this.shadowRoot?.querySelectorAll('committee-accordion');
        if (accordions) {
            accordions.forEach((accordion) => {
                if (accordion.open && accordion.folder?.id != committee.id && accordion.folder?.folderType == committee.folderType) {
                    accordion.close();
                } 
            });
        }
    }

    private async loadCommittees() {
        try {
            this.CommitteeData = await DataService.GetCommittees(this.sessionId, VaultType.Audio);
            this.IsDataLoaded = true;
        
            this.requestUpdate(); // Trigger re-render after fetching offices
        } catch (error) {
            console.error('Error fetching committees:', error);
            this.IsDataLoaded = true;
        }
    }
  
    private CreatePlayer(folder: VaultFolder, file: VaultFile, isSubApp: boolean): TemplateResult {
     
   
        const audioUrl = `/umbraco/surface/DownLoadFile?SessionId=${this.sessionId}&Vault=${VaultType.Audio}&FolderType=${isSubApp ? FolderType.SubCommittee : FolderType.Standing}&CommitteeId=${folder.id}&DocumentId=${file.documentId}&name=${file.name}`;

        return html`
            ${file.name}<br>
            <audio controls preload="none">
                <source src="${audioUrl}" type="audio/mpeg">
                Your browser does not support playing the audio directly. <a href="${audioUrl}&IsDownload=true">Download</a>
            </audio>
        `;
    }  


    private setupAudioEventListeners() {
        const audioElements = this.shadowRoot?.querySelectorAll('audio');
        if (audioElements) {
            audioElements.forEach((audio) => {
                audio.addEventListener('play', () => {
                    this.pauseAllOtherAudio(audio);
                });
            });
        }
    }

    private pauseAllOtherAudio(currentAudio: HTMLAudioElement) {
        const audioElements = this.shadowRoot?.querySelectorAll('audio');
        if (audioElements) {
            audioElements.forEach((audio) => {
                if (audio !== currentAudio) {
                    audio.pause();
                }
            });
        }
    }

    private GetHeader(folderType: FolderType) {

        if (folderType == FolderType.Meeting || folderType == FolderType.None)
            return "";

        if (folderType == FolderType.Standing || folderType == FolderType.SubCommittee || folderType == FolderType.Statutory)
            return html`<h3 class="header">Recordings</h3>`;

        if (folderType == FolderType.SubCommitteeParent)
            return html`<h3 class="header">Sub Committees</h3>`;

        return "";
    }

    private GenerateTree(folder: VaultFolder, isSubApp:boolean): TemplateResult {
        return html`
           <li style=width:75%>
            <committee-accordion .folder="${folder}">
                        <div slot="header">
                            ${folder.name} <span ?hidden=${folder.files.length == 0}>(${folder.files.length} files)</span>
                        </div>
                        <div slot="content" class="committeeDisplay">         
                         ${this.GetHeader(folder.folderType)}
                            ${folder.subFolders.map(subfolder => html`
                                ${this.GenerateTree(subfolder, isSubApp)}
                            `)}
                         
                            ${folder.files.map(file => html`
                                <li class="AudioFile">
                                     ${this.CreatePlayer(folder, file, isSubApp)}
                                </li>
                            `)}

                            ${folder.files.length == 0 ? html`
                               <li>Currently no meetings have been archived for this committee</li>
                            `: ``}                        
                        </div>
                    </committee-accordion> 
            </li>
    `;
    }


  render() {
      return html`
       <link href="/css/styles.css" rel="stylesheet" />
       <div ?hidden=${this.IsDataLoaded}>Loading Files</div> 
       <div ?hidden=${!this.IsDataLoaded || (this.CommitteeData != null && this.CommitteeData.subFolders != null && this.CommitteeData.subFolders.length > 0)}>No files have been archived yet.</div>
       <div ?hidden=${this.CommitteeData == null || this.CommitteeData.subFolders == null || this.CommitteeData.subFolders.length == 0 } class="CommitteeVaultList mt-3">
             <div id="docTree">
                  ${this.CommitteeData?.subFolders.map((committee) => html`
                    ${this.GenerateTree(committee, committee.folderType == FolderType.SubCommitteeParent) }
                  `)}
             </div>
      </div>
    `
  }
 
    static styles = css`


    ul {
        overflow: hidden;
        transition: height 0.3s ease;
        height: auto;
    }

    ul.hidden {
        height: 0;
    }

    li{
        margin:10px;
    }

    .AudioFile {
 
            margin:5px 0 15px 0
        }
    .committee{
        background-color: rgb(99, 129, 220);
        color: #fff;
        padding: 5px 10px;
        border-radius: 10px;
         display: inline-block;
         cursor: pointer;
    }

    .open{
           background-color:#000;
    }
`
}

declare global {
  interface HTMLElementTagNameMap {
      'audio-vault': AudioVault
  }
}
 
 
//allow subcommitteess to be displayed
//add audio file size and date modified
                  //do the documents one 